"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("webmotors-react-pj/utils");
var _style = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/items/user/style"));
var _icon = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/items/user/icon"));
var _popover = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/items/user/popover"));
var _v = _interopRequireDefault(require("webmotors-react-pj/tag-analytics/v2"));
var _default = () => {
  const jwt = (0, _utils.jwtGet)();
  const handleAnalyticEvent = () => {
    (0, _v.default)('pj_cockpit_iconeConta', {
      site: {
        subEnvironment: 'homepage'
      },
      page: {
        flowType: 'cockpit',
        pageType: 'cockpit-homepage',
        pageName: '/webmotors/cockpit/homepage',
        'pageName.tier1': 'cockpit',
        'pageName.tier2': 'homepage',
        'pageName.tier3': undefined,
        loadTime: window.performance.timing.navigationStart
      }
    });
  };
  return _react.default.createElement(_style.default, {
    onClick: () => handleAnalyticEvent()
  }, _react.default.createElement(_icon.default, {
    "data-qa": "header-user-menu-icon",
    "data-icon-click": true
  }, jwt.nameid && jwt.nameid[0] || '🛱'), _react.default.createElement(_popover.default, null));
};
exports.default = _default;